import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AddImages from 'modules/views/shared/AddImages';
import { FieldWrapper, IField } from 'modules/views/pages/PersonalInformation/components/fieldWrapper';
import { IFile } from 'models/general';

import { IProfileInformationSchema } from '../schema';
import { useStyles } from '../styles';

interface IGovtIdImageField {
  isVisible: boolean;
  isRequired: boolean;
}

interface IGovernmentIdSectionProps {
  govtIdFields: IField[];
  govtIdImageField: IGovtIdImageField;
  governmentDocumentFiles: any[];
  deleteId: string | null;
  values: IProfileInformationSchema;
  errors: Record<string, { message: string } | undefined>;
  setValue: (key: keyof IProfileInformationSchema, value: any) => void;
  onAddGovernmentDocumentFile: (file: any) => void;
  onDeleteGovernmentDocumentFile: (file: IFile) => void;
}

const GovernmentIdSection: React.FC<IGovernmentIdSectionProps> = ({
  govtIdFields,
  govtIdImageField,
  governmentDocumentFiles,
  deleteId,
  values,
  errors,
  setValue,
  onAddGovernmentDocumentFile,
  onDeleteGovernmentDocumentFile,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <p className={classes.sectionTitle} data-testid="profile-section-title-govt-id">
        {t('personalInformation.govtId.title')}
      </p>
      <Grid container spacing={3} data-testid="profile-section-govt-id">
        {govtIdFields.map((field, index) => (
          <Grid item xs={12} md={6} lg={4} key={field.id}>
            <FieldWrapper
              field={field}
              index={index}
              value={values[field.id]}
              setValue={value => {
                setValue(field.id as keyof IProfileInformationSchema, value);
                if (field.id === 'identificationTypeId') {
                  setValue('identificationGeographicLocationId', null);
                  setValue('otherIdentificationType', null);
                }
              }}
              error={errors[field.id]?.message}
              options={field.options}
            />
          </Grid>
        ))}
      </Grid>
      <div className={classes.addImageContainer}>
        <AddImages
          images={governmentDocumentFiles?.filter(file => !file.isDeleted)}
          deleteId={deleteId}
          required={govtIdImageField.isRequired}
          error={errors.governmentDocumentFiles?.message}
          testId="govt-id-image"
          onCapture={onAddGovernmentDocumentFile}
          onDelete={onDeleteGovernmentDocumentFile}
          multiple={true}
          isPdfEnabled={false}
        />
      </div>
    </>
  );
};

export default GovernmentIdSection;
